export const createTitle = (title?: string) => {
  const baseTitle = "LiquiDonate";
  return title ? `${title} | ${baseTitle}` : baseTitle;
};
